import { cloneDeep } from '@apollo/client/utilities';


export const sortByDate = (arr: any[], key: string = 'createdAt') => {
  return cloneDeep(arr).sort((a: any, b: any) => +new Date(a[key]) - +new Date(b[key]));
}
